var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpouseMe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Spouse_Me_svg__a,.Spouse_Me_svg__b{fill:none}.Spouse_Me_svg__b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Spouse_Me_svg__a",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Spouse_Me_svg__b",
    d: "M8.505 7.572a2.252 2.252 0 11-3.185 0 2.252 2.252 0 013.185 0M18.681 7.572a2.252 2.252 0 11-3.185 0 2.252 2.252 0 013.185 0M6.912 13.135c2.574 0 5.088 1.112 5.088 2.822v.57a.566.566 0 01-.565.565H2.389a.566.566 0 01-.565-.565v-.57c0-1.711 2.513-2.822 5.088-2.822M17.088 13.135c2.574 0 5.088 1.112 5.088 2.822v.57a.566.566 0 01-.565.565h-9.046a.566.566 0 01-.565-.565v-.57c0-1.711 2.513-2.822 5.088-2.822"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Spouse_Me_svg__a",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgSpouseMe;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Aflac/icons/Spouse_Me.svg
// module id = 1085
// module chunks = 13